import React from 'react'
import { Link } from "react-router-dom"
import CardUI from '../../../widgets/layout/CardUI.js'
import SpinnerUI from '../../../widgets/output/SpinnerUI.js'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI.js'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import RecurringTransferCreateModalSF from '../../../components/superUser/account/RecurringTransferCreateModalSF.js'
import RecurringTransferUpdateModalSF from '../../../components/superUser/account/RecurringTransferUpdateModalSF.js'
import SelectSingleSF from '../../../widgets/input/SelectSingleSF.js'
import './EventListPage.css'

const RecurringTransferPageUI = ({ context, account, scheduledTaskList, onRefreshClick,
  createMode, onScheduledTaskCreateClick, onScheduledTaskCreateCancel,
  updateMode, onScheduledTaskUpdateClick, onScheduledTaskUpdateCancel, selectedScheduledTask,
  deleteMode, onScheduledTaskDeleteClick,
  standingInstructionLogList, filteredStandingInstructionLogList, details, onDetailsClick,
  yearMonthList, selectedYearMonth, onYearMonthChange
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_cal' backLink='/su/accounts'
    headerText={account && account.accountName} centered={!account || !scheduledTaskList}
    account={account} page='recurringTransfers'
  >
    {
      (!account || !scheduledTaskList) &&
      <SpinnerComponentUI />
    }
    {
      account && scheduledTaskList &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <div className='g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              {
                context.permissions.includes('su_superuser_business') &&
                <IconButtonUI icon='icon-plus' onClick={onScheduledTaskCreateClick} />
              }
              <span className='g_m_left_100 g_large'><b>Standing Instructions</b></span>
            </div>
          }
          right={<span />}
        />
        {
          scheduledTaskList.length > 0 &&
          <ScheduledTaskUI context={context} scheduledTaskList={scheduledTaskList} selectedScheduledTask={selectedScheduledTask}
            onScheduledTaskUpdateClick={onScheduledTaskUpdateClick}
            onScheduledTaskDeleteClick={onScheduledTaskDeleteClick} deleteMode={deleteMode} />
        }
        {
          scheduledTaskList.length === 0 &&
          <span className='g_text_centre g_m_top_50 g_muted'>No standing Instructions</span>
        }
        {
          standingInstructionLogList && standingInstructionLogList.length > 0 &&
          <div className='g_m_top_50'>
            <StandingInstructionLogMonthListUI
              context={context}
              eventLogMonthList={filteredStandingInstructionLogList}
              onRefreshClick={onRefreshClick}
              onDetailsClick={onDetailsClick}
              details={details}
              yearMonthList={yearMonthList}
              selectedYearMonth={selectedYearMonth}
              onYearMonthChange={onYearMonthChange}
            />
          </div>
        }
      </div>
    }

    <RecurringTransferCreateModalSF context={context} account={account}
      onRefreshClick={onRefreshClick} createMode={createMode} onCancelClick={onScheduledTaskCreateCancel}
    />

    <RecurringTransferUpdateModalSF context={context} account={account} scheduledTask={selectedScheduledTask}
      onRefreshClick={onRefreshClick} updateMode={updateMode} onCancelClick={onScheduledTaskUpdateCancel}
    />

  </SuperUserAccountPageUI>

const ScheduledTaskUI = ({ context, scheduledTaskList, selectedScheduledTask, onScheduledTaskUpdateClick,
  onScheduledTaskDeleteClick, deleteMode }) =>
  <CardUI className='g_m_bottom_100'>
    <table className='g_table g_table_3'>
      <thead>
        <tr>
          <th className='g_th g_th_col_24'>Beneficiary Name</th>
          <th className='g_th g_th_col_16 g_td_nowrap'>Account No.</th>
          <th className='g_th g_th_col_12 g_td_nowrap'>IFSC Code</th>
          <th className='g_th g_th_col_12 g_td_nowrap'>Start Date</th>
          <th className='g_th g_th_col_12 g_td_nowrap'>End Date</th>
          <th className='g_th g_th_col_14 g_text_right g_td_nowrap'>Amount</th>
          <th className='g_th g_th_col_12 g_text_right g_td_nowrap'>Actions</th>
        </tr>
      </thead>
      <tbody>
        {
          scheduledTaskList && scheduledTaskList.map((scheduledTask, i) =>
            <tr key={i}>
              <td className='g_td g_text_top'>{scheduledTask.vendorName}</td>
              <td className='g_td g_td_nowrap'>{scheduledTask.vendor.bankAccountNumber}</td>
              <td className='g_td g_td_nowrap'>{scheduledTask.vendor.bankIFSCCode}</td>
              <td className='g_td g_td_nowrap'>{scheduledTask.startDateISO}</td>
              <td className='g_td g_td_nowrap'>{scheduledTask.endDateISO}</td>
              <td className='g_td g_td_nowrap g_text_right'>{scheduledTask.paymentAmountF2}</td>
              <td className='g_td'>
                <div className='g_action_buttons g_flex_right'>
                  {
                    context.permissions.includes('su_superuser_business') &&
                    <span className='icon icon-pencil g_link_2 g_cursor_pointer' onClick={onScheduledTaskUpdateClick}
                      data-id={scheduledTask.scheduledTaskId} />
                  }
                  <span className='icon icon-trash-o g_link_2 g_cursor_pointer g_delete_icon' onClick={onScheduledTaskDeleteClick}
                    data-id={scheduledTask.scheduledTaskId} />
                  <SpinnerUI show={deleteMode && selectedScheduledTask
                    && selectedScheduledTask.scheduledTaskId === scheduledTask.scheduledTaskId} />
                </div>
              </td>
            </tr>
          )
        }
      </tbody>
    </table>
  </CardUI>

const StandingInstructionLogMonthListUI = ({ context, eventLogMonthList, onRefreshClick, onDetailsClick, details,
  yearMonthList, selectedYearMonth, onYearMonthChange
}) =>
  <div>
    <LRTableActionsUI location='top'
      left={
        <div className='g_flex_h'>
          <span className='g_m_left_100 g_large'><b>Standing Instruction Logs</b></span>
        </div>
      }
      right={
        <span className='g_flex_h'>
          <div className='g_m_right_100' style={{ width: '200px' }}>
            <SelectSingleSF
              optionList={yearMonthList}
              selectedKey={selectedYearMonth}
              onChange={onYearMonthChange}
            />
          </div>
          <Link to='#' onClick={onDetailsClick}>Details</Link>
        </span>
      }
    />
    {
      eventLogMonthList && eventLogMonthList.length > 0 &&
      eventLogMonthList.map((eventLogMonth, i) =>
        <CardUI key={i} title={eventLogMonth.yearMonth} className='g_m_bottom_100' noUnderline={true}>
          <StandingInstructionLogListUI context={context} eventLogList={eventLogMonth.eventLogList} details={details} />
        </CardUI>
      )
    }
    {
      eventLogMonthList && eventLogMonthList.length === 0 &&
      <span className='g_text_centre'>No logs found for selected period</span>
    }
  </div>

const StandingInstructionLogListUI = ({ context, eventLogList, details }) =>
  <LRTableBodyUI className='g_m_top_25'>
    {
      eventLogList.filter(e => e.eventType !== 'loan_status_update_in_console').map((eventLog, i) =>
        <StandingInstructionLogRowUI key={i} context={context} eventLog={eventLog} details={details} />
      )
    }
  </LRTableBodyUI>

const StandingInstructionLogRowUI = ({ context, eventLog, details }) =>
  <LRTableRowUI
    context={context} className='g_flex_top'
    left={<StandingInstructionRowLeftUI context={context} eventLog={eventLog} details={details} />}
    right={<StandingInstructionRowRightUI eventLog={eventLog} details={details} />}
  />

const StandingInstructionRowLeftUI = ({ context, eventLog, details }) =>
  <div className='g_flex_v'>
    <span className='g_flex_v'>
      <span><b>
        {eventLog.eventLabel}
        {
          eventLog.recurrence > 1 &&
          <span className='g_m_left_100 g_muted'>{eventLog.recurrence} times</span>
        }
      </b></span>
      <span className='g_muted'>{eventLog.dateCreatedF} IST</span>
    </span>
    {
      details &&
      <>
        {
          eventLog.eventType === 'email_to_client' &&
          <span className='g_m_top_25'>
            Subject: {eventLog.emailSubject}
            <div dangerouslySetInnerHTML={{ __html: eventLog.emailMessage }} />
          </span>
        }
        {
          eventLog.eventDetails &&
          <span>{eventLog.eventDetails}</span>
        }
        {
          eventLog.userName &&
          <span className='g_muted'>By: {eventLog.userName}</span>
        }
        <span className='g_muted g_small'>Internal Ref: {eventLog.ecid} {eventLog.ipAddress}</span>
      </>
    }
  </div>

const StandingInstructionRowRightUI = ({ eventLog, details }) =>
  <>
    {
      !details && eventLog.amountF2 &&
      <span className='g_flex_v g_flex_right g_text_right'>
        {eventLog.amountF2}
        <span className='g_muted'>{eventLog.amountLabel}</span>
      </span>
    }
    {
      details &&
      <table><tbody>
        {
          eventLog.amountF2 &&
          <tr>
            <td className='label g_muted'>{eventLog.amountLabel}</td>
            <td className='chomp'>{eventLog.amountF2}</td>
          </tr>
        }
        {
          eventLog.payLoadMap && Object.entries(eventLog.payLoadMap).map(([key, value]) =>
            <tr key={key}>
              <td className='label g_muted'>{key}</td>
              <td className='chomp'><span>{value}</span>
              </td></tr>
          )
        }
      </tbody></table>
    }
  </>

export default RecurringTransferPageUI
